module.exports = __webpack_public_path__ + "static/media/yellow-110.5fd71dfe.png";